import React from 'react';
import _ from 'underscore';

const fonts = [
  {name:'Arial', value:'Arial'},
  {name:'Arial Black', value:'Arial Black'},
  {name:'Georgia', value:'Georgia'},
  {name:'Serif', value:'sans-serif'},
  {name:'Helvetica', value:'Helvetica'},
  {name:'Times New Roman', value:'Times New Roman'},
  {name:'Courier', value:'Courier'},
  {name:'Tahoma', value:'Tahoma'},
];

// Array of html options.
const createFontOptions = () => {
  return _.map(fonts, f => {
    return <option key={f.value} value={f.value}>{f.name}</option>
  });
};

class TextEditor extends React.Component {
  constructor(props) {
    super(props);
    const {wlf, type} = props;

    this.state = {
      displayTextEditor: true,
      text: wlf.css[type].text,
      size: wlf.css[type].size,
      font: wlf.css[type].font,
      bold: !!wlf.css[type].bold,
    };
  }

  changeText = (e) => {
    this.setState({text:e.currentTarget.value});
    this.props.onChange({
      text:e.currentTarget.value,
      size:this.state.size,
      font:this.state.font,
      bold: this.state.bold,
    }, this.props.type)
  };

  changeFont = (e) => {
    this.setState({font:e.currentTarget.value});
    this.props.onChange({
      font:e.currentTarget.value,
      text:this.state.text,
      size:this.state.size,
      bold: this.state.bold,
    }, this.props.type)
  };

  changeFontSize = (e) => {
    this.setState({size:parseInt(e.currentTarget.value, 10)});
    this.props.onChange({
      size:e.currentTarget.value,
      text:this.state.text,
      font:this.state.font,
      bold: this.state.bold,
    }, this.props.type)
  };

  dumpBold = () => {
    const style = {
      margin: "0.5rem",
    };
    const pStyle = {
      paddingTop: "0.5rem",
    };

    return (
      <p className="control" style={pStyle}>
        <span style={style}>
          Bold: <input type="checkbox" onChange={this.onBold} checked={this.state.bold} />
        </span>
      </p>
    );
  };

  onBold = e => {
    const checked = e.currentTarget.checked;

    this.setState({bold: checked});
    this.props.onChange({
      size: this.state.size,
      text: this.state.text,
      font: this.state.font,
      bold: checked,
    }, this.props.type);
  };

  render = () => {
    const {title} = this.props;
    const {text, size} = this.state;

    const fontSizes = _.map(_.range(8, 41), s => {
      return <option key={s} value={s}>{s}</option>
    });

    return (
      <div className="text-editor">
        <div className="text-edit-title">
            {title}
        </div>
        <div className="field has-addons">
          <p className="control">
              <input className="input" type="text"
                     placeholder="" style={{width:'30rem'}}
                     value = {text}
                     onChange={this.changeText}/>
          </p>
          <p className="control">
              <span className="select">
                  <select onChange={this.changeFontSize} value={size}>
                    {fontSizes}
                  </select>
              </span>
          </p>
          { this.dumpBold() }
        </div>
      </div>
    )
  }
}

export { TextEditor, createFontOptions };
